import { initializeCart } from '../updateCart';

export default class CartDrawer {
  constructor() {
    this.cart = document.getElementById('shopify-section-cart');
    this.closeButton = this.cart.querySelector('button[name="close"]');
    this.addFreeSampleButtons = this.cart.querySelectorAll('.free-sample .item');

    this.closeButton.addEventListener('click', this.closeCart.bind(this));
    this.addFreeSampleButtons.forEach((button) => {
      button.addEventListener('click', this.addFreeSample.bind(this));
    });

    this.cart.classList.add('cart-drawer-container');
    this.cart.classList.add('cart-drawer-container--ajax');

    //click outside cart closes drawer
    document.documentElement.addEventListener('click', this.closeCart.bind(this));
    this.cart.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    initializeCart();
  }

  closeCart() {
    document.querySelector('body').classList.remove('cart-open');
    this.cart.classList.remove('show');
  }

  addFreeSample(e) {
    let target = e.target;

    const freeSampleContainer = document.querySelector('.cart-drawer-container .free-sample');

    // Disable add free sample button if one already added
    freeSampleContainer.classList.add('hidden');

    while (!target.classList.contains('item')) target = target.parentElement;

    const variantId = target.dataset.id;

    fetch('/cart.js', { method: 'GET' })
      .then((res) => res.json())
      .then((res) => {
        // Check if free sample is already added
        let freeSampleExists = false;
        res.items.forEach((item) => {
          if (item.properties) {
            if (item.properties.free_sample === true) freeSampleExists = true;
          }
        });

        return freeSampleExists;
      })
      .then((freeSampleExists) => {
        // Only add free sample only if there is none
        if (!freeSampleExists) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              quantity: 1,
              id: variantId,
              properties: {
                free_sample: true
              }
            })
          })
            .then((res) => {
              if (res.ok) return res.json();
              else throw Error(`Request rejected with status ${res.status}`);
            })
            .then(() => {
              initializeCart();
            })
            .catch(console.log);
        }
      })
      .catch(console.log);
  }
}
